import React from 'react';

import CreateVideoNewPage from '../CreateVideoNewPage';

/**
 * Router component for video creation/editing.
 * 
 * Now uses the new unified editor for both mobile and desktop.
 * The new editor handles mobile uploads via a simplified flow:
 * - Mobile: Shows upload menu, creates 'mobile uploads' type meeting, auto-redirects
 * - Desktop: Full editor with timeline, preview, and multi-section support
 */
export default function CreateVideoRouter() {
  return <CreateVideoNewPage />;
}
